import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { Domain } from '@shared/app/scripts/services/domain';
import { SessionManager } from '@shared/app/scripts/services/session-manager';
import { UserSession } from '@core/app/scripts/services/user-session';

angular
  .module('posApp')
  .controller(
    'dashboardController',
    (
      $scope: ng.IScope,
      $window: ng.IWindowService,
      domain: Domain,
      navigateTo: NavigateTo,
      sessionManager: SessionManager,
      userSession: UserSession,
    ) => {
      $scope.navigateToView = (view) => {
        navigateTo(view);
      };

      $scope.logout = () => {
        sessionManager.logout();
      };

      $scope.goHome = () => {
        $window.location.href = domain.link('www');
      };

      /**
       * BO-94 Only show menus if the user belongs to the Polytex tenant
       */
      $scope.isPolytex = userSession.isPolytex;
    },
  );
